document.addEventListener('DOMContentLoaded', function () {

  /* ===== Rotating announcement bar ===== */
  var announcementMsgs = document.querySelectorAll('#AnnouncementBar .announcement-msg');
  if (announcementMsgs.length > 1) {
    var annCurrent = 0;
    setInterval(function () {
      announcementMsgs[annCurrent].classList.remove('is-active');
      annCurrent = (annCurrent + 1) % announcementMsgs.length;
      announcementMsgs[annCurrent].classList.add('is-active');
    }, 3500);
  }

  /* ===== Product rating: fill % and "X,XX/5" text computed in JS ===== */
  /* Liquid arithmetic filters (times/divided_by/round) did not reliably coerce these specific
     metafield values on this store, so the raw numbers are passed through as data attributes
     and the math happens here instead, where it's easy to guard with isNaN checks. */
  var ratingEls = document.querySelectorAll('[data-product-rating]');
  ratingEls.forEach(function (el) {
    var rating = parseFloat(el.getAttribute('data-rating'));
    var max = parseFloat(el.getAttribute('data-rating-max'));
    if (isNaN(rating)) return;
    if (isNaN(max) || max <= 0) max = 5;
    var percent = Math.max(0, Math.min(100, (rating / max) * 100));
    var fill = el.querySelector('[data-rating-fill]');
    if (fill) fill.style.width = percent + '%';
    var valueEl = el.querySelector('[data-rating-value]');
    if (valueEl) valueEl.textContent = rating.toFixed(2).replace('.', ',') + '/5';
  });

  /* ===== Product rating -> scroll to the Judge.me reviews block ===== */
  /* `[id$="..."]` matches on the stable block-key suffix so this keeps working even if
     Shopify regenerates the random block-id prefix (shopify-block-<random>__<key>).
     Falls back to scrolling just above the footer if the reviews block isn't on the page. */
  var scrollToReviewsTriggers = document.querySelectorAll('[data-scroll-to-reviews]');
  if (scrollToReviewsTriggers.length) {
    var reviewsBlock = document.querySelector('[id*="judge_me_reviews_review_widget"]');
    var siteFooter = document.querySelector('footer.site-footer') || document.querySelector('footer');
    var scrollTarget = reviewsBlock || siteFooter;
    if (scrollTarget) {
      scrollToReviewsTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }
  }

  /* ===== Scroll reveal animation ===== */
  var revealEls = document.querySelectorAll('.reveal-on-scroll');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ===== Search drawer (live predictive search) ===== */
  var searchTriggers = document.querySelectorAll('[data-search-trigger]');
  var searchDrawer = document.getElementById('SearchDrawer');
  var searchOverlay = document.getElementById('SearchDrawerOverlay');
  var searchClose = document.getElementById('SearchDrawerClose');
  var searchInput = document.getElementById('SearchDrawerInput');
  var searchResults = document.getElementById('SearchDrawerResults');
  var searchDebounce;

  function openSearchDrawer() {
    if (searchDrawer) searchDrawer.classList.add('is-open');
    if (searchOverlay) searchOverlay.classList.add('is-open');
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 100);
  }
  function closeSearchDrawer() {
    if (searchDrawer) searchDrawer.classList.remove('is-open');
    if (searchOverlay) searchOverlay.classList.remove('is-open');
  }
  searchTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      closeMobileMenu();
      openSearchDrawer();
    });
  });
  if (searchClose) searchClose.addEventListener('click', closeSearchDrawer);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearchDrawer);

  var strings = window.themeStrings || {};

  function renderSearchResults(data, term) {
    if (!searchResults) return;
    var products = data.resources.results.products || [];
    var pages = (data.resources.results.pages || []).concat(data.resources.results.articles || []);

    if (products.length === 0 && pages.length === 0) {
      var noResultsText = (strings.searchNoResults || 'No results for "__TERM__".').replace('__TERM__', term);
      searchResults.innerHTML =
        '<div class="search-empty">' +
          '<p>' + noResultsText + '</p>' +
          '<p class="search-empty-sub">' + (strings.searchNoResultsHint || '') + '</p>' +
          '<div class="search-empty-actions">' +
            '<a href="/collections/sante-bien-etre" class="btn btn-outline">Sante et bien-etre</a>' +
            '<a href="/collections/smart-life" class="btn btn-outline">Smart life</a>' +
          '</div>' +
        '</div>';
      return;
    }

    var html = '';
    if (products.length > 0) {
      html += '<p class="search-drawer-section-title">' + (strings.searchProductsHeading || 'Products') + '</p><div class="search-drawer-products">';
      products.forEach(function (p) {
        html += '<a href="' + p.url + '" class="search-drawer-product">' +
          '<img src="' + (p.featured_image ? p.featured_image.url : '') + '" alt="' + p.title + '">' +
          '<p class="search-drawer-product-title">' + p.title + '</p>' +
          '<p class="search-drawer-product-price">' + p.price + '</p>' +
        '</a>';
      });
      html += '</div>';
    }
    if (pages.length > 0) {
      html += '<p class="search-drawer-section-title">' + (strings.searchPagesHeading || 'Pages') + '</p><div class="search-drawer-pages">';
      pages.forEach(function (pg) {
        html += '<a href="' + pg.url + '" class="search-drawer-page-link">' + pg.title + '</a>';
      });
      html += '</div>';
    }
    searchResults.innerHTML = html;
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(searchDebounce);
      if (term.length < 2) {
        searchResults.innerHTML = '<p class="search-drawer-hint">' + (strings.searchHint || '') + '</p>';
        return;
      }
      searchDebounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,page,article&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (data) { renderSearchResults(data, term); })
          .catch(function () {
            searchResults.innerHTML = '<p class="search-drawer-hint">Une erreur est survenue, reessaie.</p>';
          });
      }, 300);
    });
  }

  /* ===== Mobile menu drawer ===== */
  var mobileToggle = document.getElementById('MobileMenuToggle');
  var mobileDrawer = document.getElementById('MobileMenuDrawer');
  var mobileOverlay = document.getElementById('MobileMenuOverlay');
  function closeMobileMenu() {
    if (mobileDrawer) mobileDrawer.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
  }
  if (mobileToggle && mobileDrawer && mobileOverlay) {
    mobileToggle.addEventListener('click', function () {
      var isOpen = mobileDrawer.classList.toggle('is-open');
      mobileOverlay.classList.toggle('is-open', isOpen);
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
    });
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }

  /* ===== Product gallery thumbnails ===== */
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImage = document.getElementById('MainProductImage');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var url = thumb.getAttribute('data-image-url');
      if (mainImage && url) mainImage.src = url;
      if (mainImage) mainImage.setAttribute('data-current-index', thumb.getAttribute('data-index') || 0);
    });
  });

  /* ===== Product image modal (slider + click-to-zoom) ===== */
  var mediaModal = document.getElementById('ProductMediaModal');
  var mediaModalOverlay = document.getElementById('ProductMediaModalOverlay');
  var mediaModalTrack = document.getElementById('ProductMediaModalTrack');
  if (mediaModal && mediaModalTrack) {
    var mediaModalClose = document.getElementById('ProductMediaModalClose');
    var mediaModalPrev = document.getElementById('ProductMediaModalPrev');
    var mediaModalNext = document.getElementById('ProductMediaModalNext');
    var mediaModalCounter = document.getElementById('ProductMediaModalCounter');
    var mediaModalSlides = mediaModalTrack.querySelectorAll('.product-modal-slide');
    var mediaModalIndex = 0;

    function resetModalZoom() {
      mediaModalSlides.forEach(function (slide) {
        var img = slide.querySelector('[data-modal-image]');
        if (img) img.classList.remove('is-zoomed');
      });
    }

    function goToModalSlide(index) {
      if (index < 0) index = mediaModalSlides.length - 1;
      if (index >= mediaModalSlides.length) index = 0;
      mediaModalIndex = index;
      mediaModalTrack.style.transform = 'translateX(-' + (mediaModalIndex * 100) + '%)';
      if (mediaModalCounter) mediaModalCounter.textContent = (mediaModalIndex + 1) + ' / ' + mediaModalSlides.length;
      resetModalZoom();
    }

    function openMediaModal(index) {
      goToModalSlide(index || 0);
      mediaModal.classList.add('is-open');
      if (mediaModalOverlay) mediaModalOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeMediaModal() {
      mediaModal.classList.remove('is-open');
      if (mediaModalOverlay) mediaModalOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      resetModalZoom();
    }

    document.querySelectorAll('[data-open-modal-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = mainImage ? parseInt(mainImage.getAttribute('data-current-index'), 10) || 0 : 0;
        openMediaModal(index);
      });
    });
    if (mainImage) {
      mainImage.addEventListener('click', function () {
        var index = parseInt(mainImage.getAttribute('data-current-index'), 10) || 0;
        openMediaModal(index);
      });
    }
    if (mediaModalClose) mediaModalClose.addEventListener('click', closeMediaModal);
    if (mediaModalOverlay) mediaModalOverlay.addEventListener('click', closeMediaModal);
    if (mediaModalPrev) mediaModalPrev.addEventListener('click', function () { goToModalSlide(mediaModalIndex - 1); });
    if (mediaModalNext) mediaModalNext.addEventListener('click', function () { goToModalSlide(mediaModalIndex + 1); });

    document.addEventListener('keydown', function (e) {
      if (!mediaModal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeMediaModal();
      if (e.key === 'ArrowLeft') goToModalSlide(mediaModalIndex - 1);
      if (e.key === 'ArrowRight') goToModalSlide(mediaModalIndex + 1);
    });

    mediaModalTrack.querySelectorAll('[data-modal-image]').forEach(function (img) {
      img.addEventListener('click', function (e) {
        e.stopPropagation();
        img.classList.toggle('is-zoomed');
      });
      img.addEventListener('mousemove', function (e) {
        if (!img.classList.contains('is-zoomed')) return;
        var rect = img.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
    });

    /* Touch swipe to change slide */
    var touchStartX = 0;
    var touchStartY = 0;
    var isTouchSwiping = false;

    mediaModalTrack.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isTouchSwiping = true;
    }, { passive: true });

    mediaModalTrack.addEventListener('touchend', function (e) {
      if (!isTouchSwiping) return;
      isTouchSwiping = false;
      var touch = e.changedTouches[0];
      var deltaX = touch.clientX - touchStartX;
      var deltaY = touch.clientY - touchStartY;
      if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
        goToModalSlide(mediaModalIndex + (deltaX < 0 ? 1 : -1));
      }
    }, { passive: true });
  }

  /* ===== Hero carousel ===== */
  var heroSection = document.getElementById('HeroCarousel');
  var track = document.getElementById('HeroCarouselTrack');
  if (track && heroSection) {
    var slides = track.children;
    var dots = document.querySelectorAll('#HeroDots .hero-carousel-dot');
    var current = 0;
    var autoplayEnabled = heroSection.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(heroSection.getAttribute('data-autoplay-speed'), 10) || 5000;
    function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }
    var prevBtn = document.getElementById('HeroPrev');
    var nextBtn = document.getElementById('HeroNext');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goToSlide(i); });
    });
    if (slides.length > 1 && autoplayEnabled) {
      setInterval(function () { goToSlide(current + 1); }, autoplaySpeed);
    }

    /* Touch swipe to change slide on mobile */
    if (slides.length > 1) {
      var heroTouchStartX = 0;
      var heroTouchStartY = 0;
      var heroIsTouchSwiping = false;

      track.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        heroTouchStartX = e.touches[0].clientX;
        heroTouchStartY = e.touches[0].clientY;
        heroIsTouchSwiping = true;
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        if (!heroIsTouchSwiping) return;
        heroIsTouchSwiping = false;
        var touch = e.changedTouches[0];
        var deltaX = touch.clientX - heroTouchStartX;
        var deltaY = touch.clientY - heroTouchStartY;
        if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
          goToSlide(current + (deltaX < 0 ? 1 : -1));
        }
      }, { passive: true });
    }
  }

  /* ===== Product / related carousels (horizontal scroll) ===== */
  document.querySelectorAll('[data-carousel-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var el = document.getElementById(btn.getAttribute('data-carousel-prev'));
      if (el) el.scrollBy({ left: -240, behavior: 'smooth' });
    });
  });
  document.querySelectorAll('[data-carousel-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var el = document.getElementById(btn.getAttribute('data-carousel-next'));
      if (el) el.scrollBy({ left: 240, behavior: 'smooth' });
    });
  });

  /* ===== Scroll to buy button (product final CTA) ===== */
  document.querySelectorAll('[data-scroll-to-buy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var target = document.querySelector('.product-sticky-buy');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ===== Language switcher ===== */
  document.querySelectorAll('[data-lang-switcher]').forEach(function (switcher) {
    var trigger = switcher.querySelector('[data-lang-trigger]');
    if (!trigger) return;

    function closeSwitcher() {
      switcher.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = switcher.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', String(isOpen));
    });

    document.addEventListener('click', function (e) {
      if (!switcher.contains(e.target)) closeSwitcher();
    });
  });

  /* ===== Out-of-stock button tooltip ===== */
  document.querySelectorAll('[data-oos-trigger]').forEach(function (btn) {
    var wrap = btn.closest('.btn-oos-wrap');
    var tooltip = wrap ? wrap.querySelector('.oos-tooltip') : null;
    if (!tooltip) return;

    function isDisabled() { return btn.getAttribute('aria-disabled') === 'true'; }
    function showTip() { if (isDisabled()) tooltip.classList.add('is-visible'); }
    function hideTip() { tooltip.classList.remove('is-visible'); }

    btn.addEventListener('mouseenter', showTip);
    btn.addEventListener('mouseleave', hideTip);
    btn.addEventListener('focus', showTip);
    btn.addEventListener('blur', hideTip);
    btn.addEventListener('click', function (e) {
      if (isDisabled()) {
        e.preventDefault();
        showTip();
      }
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) hideTip();
    });
  });

  /* ===== Cart page: quantity stepper + remove ===== */
  document.querySelectorAll('[data-cart-row]').forEach(function (row) {
    var qtyInput = row.querySelector('[data-qty-input]');
    if (!qtyInput) return;
    var form = row.closest('form');

    var decreaseBtn = row.querySelector('[data-qty-decrease]');
    var increaseBtn = row.querySelector('[data-qty-increase]');
    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(0, (parseInt(qtyInput.value, 10) || 0) - 1);
      });
    }
    if (increaseBtn) {
      increaseBtn.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 0) + 1;
      });
    }

    var removeBtn = row.querySelector('[data-cart-remove]');
    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        qtyInput.value = 0;
        if (form) form.submit();
      });
    }
  });

  /* ===== Variant picker (color/size/etc. options on product page) ===== */
  var variantPicker = document.querySelector('[data-variant-picker]');
  if (variantPicker) {
    var variantsDataEl = document.querySelector('[data-product-variants-json]');
    var productVariants = [];
    try {
      productVariants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
    } catch (e) {
      productVariants = [];
    }

    var variantIdInput = document.querySelector('[data-variant-id-input]');
    var variantPriceCurrentEl = document.querySelector('[id^="ProductPriceCurrent-"]');
    var variantPriceCompareEl = document.querySelector('[id^="ProductPriceCompare-"]');
    var variantStockStatusEl = document.querySelector('[id^="ProductStockStatus-"]');
    var variantStockTextEl = document.querySelector('[id^="ProductStockText-"]');
    var variantMainImageEl = document.getElementById('MainProductImage');
    var variantSubmitBtn = document.querySelector('[id^="ProductSubmitButton-"]');
    var variantOrderNowBtn = document.querySelector('[data-scroll-to-buy]');

    function getSelectedVariantOptions() {
      var selected = [];
      variantPicker.querySelectorAll('.variant-option-group').forEach(function (group) {
        var active = group.querySelector('.variant-card.is-selected');
        selected.push(active ? active.getAttribute('data-value') : null);
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      for (var i = 0; i < productVariants.length; i++) {
        var v = productVariants[i];
        var isMatch = v.options.length === selected.length && v.options.every(function (val, idx) {
          return val === selected[idx];
        });
        if (isMatch) return v;
      }
      return null;
    }

    function setVariantButtonState(btn, available) {
      if (!btn) return;
      btn.classList.toggle('is-disabled', !available);
      if (available) {
        btn.removeAttribute('aria-disabled');
      } else {
        btn.setAttribute('aria-disabled', 'true');
      }
      var labelAvailable = btn.getAttribute('data-label-available');
      var labelSoldOut = btn.getAttribute('data-label-sold-out');
      if (labelAvailable && labelSoldOut) {
        btn.textContent = available ? labelAvailable : labelSoldOut;
      }
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (variantPriceCurrentEl) variantPriceCurrentEl.textContent = variant.price;
      if (variantPriceCompareEl) {
        if (variant.comparePrice) {
          variantPriceCompareEl.textContent = variant.comparePrice;
          variantPriceCompareEl.classList.remove('is-hidden');
        } else {
          variantPriceCompareEl.classList.add('is-hidden');
        }
      }
      if (variantStockStatusEl) {
        variantStockStatusEl.classList.remove('stock-status-in', 'stock-status-low', 'stock-status-out');
        variantStockStatusEl.classList.add(variant.stockClass);
      }
      if (variantStockTextEl) variantStockTextEl.textContent = variant.stockText;
      if (variantMainImageEl && variant.image) variantMainImageEl.src = variant.image;
      setVariantButtonState(variantSubmitBtn, variant.available);
      setVariantButtonState(variantOrderNowBtn, variant.available);
    }

    variantPicker.addEventListener('click', function (e) {
      var valueBtn = e.target.closest('.variant-card');
      if (!valueBtn) return;
      var group = valueBtn.closest('.variant-option-group');
      group.querySelectorAll('.variant-card').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      valueBtn.classList.add('is-selected');
      var selectedLabel = group.querySelector('[data-selected-value]');
      if (selectedLabel) selectedLabel.textContent = valueBtn.getAttribute('data-value');

      applyVariant(findMatchingVariant(getSelectedVariantOptions()));
    });
  }

  /* ===== Cart drawer (AJAX Cart API) ===== */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartOverlay = document.getElementById('CartDrawerOverlay');
  var cartItemsEl = document.getElementById('CartDrawerItems');
  var cartTotalEl = document.getElementById('CartDrawerTotal');
  var headerCartCount = document.getElementById('HeaderCartCount');

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0 }) + ' FCFA';
  }

  /* ===== Cart urgency timer (10 min, shown once the cart has items) ===== */
  var URGENCY_STORAGE_KEY = 'hkvCartUrgencyStart';
  var URGENCY_DURATION_MS = 10 * 60 * 1000;
  var urgencyTimerEl = document.getElementById('CartUrgencyTimer');
  var urgencyCountdownEl = document.getElementById('CartUrgencyCountdown');
  var giftConfirmedEl = document.getElementById('CartGiftConfirmed');
  var urgencyInterval = null;

  function formatCountdown(ms) {
    var totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  function tickUrgencyTimer() {
    if (!urgencyCountdownEl) return;
    var start = parseInt(sessionStorage.getItem(URGENCY_STORAGE_KEY), 10);
    if (!start) return;
    var remaining = URGENCY_DURATION_MS - (Date.now() - start);
    if (remaining <= 0) {
      start = Date.now();
      sessionStorage.setItem(URGENCY_STORAGE_KEY, String(start));
      remaining = URGENCY_DURATION_MS;
    }
    urgencyCountdownEl.textContent = formatCountdown(remaining);
  }

  function updateUrgencyTimer(itemCount) {
    if (giftConfirmedEl) giftConfirmedEl.hidden = itemCount === 0;
    if (!urgencyTimerEl) return;
    if (itemCount > 0) {
      if (!sessionStorage.getItem(URGENCY_STORAGE_KEY)) {
        sessionStorage.setItem(URGENCY_STORAGE_KEY, String(Date.now()));
      }
      urgencyTimerEl.hidden = false;
      tickUrgencyTimer();
      if (!urgencyInterval) urgencyInterval = setInterval(tickUrgencyTimer, 1000);
    } else {
      urgencyTimerEl.hidden = true;
      sessionStorage.removeItem(URGENCY_STORAGE_KEY);
      if (urgencyInterval) {
        clearInterval(urgencyInterval);
        urgencyInterval = null;
      }
    }
  }

  function renderCart(cart) {
    if (!cartItemsEl) return;
    if (cart.item_count === 0) {
      cartItemsEl.innerHTML =
        '<div class="cart-drawer-empty">' +
          '<span class="cart-drawer-empty-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></span>' +
          '<p>' + (strings.cartEmpty || '') + '</p>' +
          '<a href="/collections/all" class="btn btn-primary">' + (strings.cartDiscoverProducts || '') + '</a>' +
        '</div>';
    } else {
      var html = '';
      cart.items.forEach(function (item) {
        var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-drawer-item-variant">' + item.variant_title + '</p>'
          : '';
        html += '<div class="cart-drawer-item" data-line-key="' + item.key + '">' +
          '<img src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
          '<div class="cart-drawer-item-info">' +
            '<p class="cart-drawer-item-title">' + item.product_title + '</p>' +
            variantLine +
            '<p class="cart-drawer-item-price">' + formatMoney(item.final_price) + '</p>' +
            '<div class="cart-drawer-qty">' +
              '<button data-qty-decrease>-</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-qty-increase>+</button>' +
              '<button class="cart-drawer-remove" data-qty-remove aria-label="' + (strings.cartRemove || 'Remove') + '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 7 20 7"/><path d="M6 7l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      });
      cartItemsEl.innerHTML = html;
    }
    if (cartTotalEl) cartTotalEl.textContent = formatMoney(cart.total_price);
    if (headerCartCount) headerCartCount.textContent = cart.item_count;
    updateUrgencyTimer(cart.item_count);
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    fetchCart();
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
  }

  var cartTrigger = document.getElementById('CartIconTrigger');
  var cartClose = document.getElementById('CartDrawerClose');
  if (cartTrigger) cartTrigger.addEventListener('click', openCartDrawer);
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  /* Quantity change / remove inside drawer */
  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', function (e) {
      var itemEl = e.target.closest('.cart-drawer-item');
      if (!itemEl) return;
      var key = itemEl.getAttribute('data-line-key');
      var qtySpan = itemEl.querySelector('.cart-drawer-qty span');
      var qty = parseInt(qtySpan.textContent, 10);

      if (e.target.closest('[data-qty-increase]')) {
        updateCartLine(key, qty + 1);
      } else if (e.target.closest('[data-qty-decrease]')) {
        updateCartLine(key, Math.max(0, qty - 1));
      } else if (e.target.closest('[data-qty-remove]')) {
        updateCartLine(key, 0);
      }
    });
  }

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* Add to cart from product form (AJAX) */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      }).then(function (r) { return r.json(); }).then(function () {
        openCartDrawer();
      }).catch(function () {
        form.submit();
      });
    });
  });

  /* Init cart count on load */
  fetchCart();
});
